import script from "./recoverycoitn.vue?vue&type=script&setup=true&lang=js"
export * from "./recoverycoitn.vue?vue&type=script&setup=true&lang=js"

import "./recoverycoitn.vue?vue&type=style&index=0&id=65340c3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65340c3e"]])

export default __exports__